var map = {
	"./AGoodNewsStoryFromPeddie": [
		360,
		59
	],
	"./AGoodNewsStoryFromPeddie.js": [
		360,
		59
	],
	"./AdviceFromTheExpertsPart10": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart10.js": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart11": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart11.js": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart5": [
		281,
		50
	],
	"./AdviceFromTheExpertsPart5.js": [
		281,
		50
	],
	"./AdviceFromTheExpertsPart6": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart6.js": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart7": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart7.js": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart8": [
		372,
		64
	],
	"./AdviceFromTheExpertsPart8.js": [
		372,
		64
	],
	"./AdviceFromTheExpertsPart9": [
		373,
		65
	],
	"./AdviceFromTheExpertsPart9.js": [
		373,
		65
	],
	"./AdviceFromTheExpertsTenantsPart1": [
		282,
		51
	],
	"./AdviceFromTheExpertsTenantsPart1.js": [
		282,
		51
	],
	"./AdviceFromTheExpertsTenantsPart2": [
		283,
		52
	],
	"./AdviceFromTheExpertsTenantsPart2.js": [
		283,
		52
	],
	"./AlternativeEnergyInstallations": [
		362,
		66
	],
	"./AlternativeEnergyInstallations.js": [
		362,
		66
	],
	"./ApplyingSASRIAExtensions": [
		374,
		67
	],
	"./ApplyingSASRIAExtensions.js": [
		374,
		67
	],
	"./AreGardensOwnedByUnitOwners": [
		284,
		68
	],
	"./AreGardensOwnedByUnitOwners.js": [
		284,
		68
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair": [
		285,
		69
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair.js": [
		285,
		69
	],
	"./CIAGeyserEmergencyAssist": [
		363,
		70
	],
	"./CIAGeyserEmergencyAssist.js": [
		363,
		70
	],
	"./CIAPrivacyPolicy": [
		375,
		15
	],
	"./CIAPrivacyPolicy.js": [
		375,
		15
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers": [
		286,
		71
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers.js": [
		286,
		71
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2": [
		287,
		72
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2.js": [
		287,
		72
	],
	"./CiaIssuesPolicy": [
		288,
		53
	],
	"./CiaIssuesPolicy.js": [
		288,
		53
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining": [
		376,
		73
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining.js": [
		376,
		73
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount": [
		289,
		54
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount.js": [
		289,
		54
	],
	"./CommonPropertyPart1": [
		377,
		74
	],
	"./CommonPropertyPart1.js": [
		377,
		74
	],
	"./CommonPropertyPart2": [
		378,
		75
	],
	"./CommonPropertyPart2.js": [
		378,
		75
	],
	"./CommonPropertyPart3": [
		379,
		76
	],
	"./CommonPropertyPart3.js": [
		379,
		76
	],
	"./CommonPropertyPart4": [
		380,
		77
	],
	"./CommonPropertyPart4.js": [
		380,
		77
	],
	"./CommonPropertyPart5": [
		381,
		78
	],
	"./CommonPropertyPart5.js": [
		381,
		78
	],
	"./CommunitySchemesTraining": [
		382,
		79
	],
	"./CommunitySchemesTraining.js": [
		382,
		79
	],
	"./ComputeCrimeClaimsPart2": [
		290,
		80
	],
	"./ComputeCrimeClaimsPart2.js": [
		290,
		80
	],
	"./ComputeCrimeClaimsPart3": [
		291,
		81
	],
	"./ComputeCrimeClaimsPart3.js": [
		291,
		81
	],
	"./ComputerCrimePolicyWordingChanges": [
		292,
		82
	],
	"./ComputerCrimePolicyWordingChanges.js": [
		292,
		82
	],
	"./ComputerCrimePolicyWordingChanges1": [
		383,
		83
	],
	"./ComputerCrimePolicyWordingChanges1.js": [
		383,
		83
	],
	"./ComputerCrimeWordingProposalFormPart1": [
		293,
		84
	],
	"./ComputerCrimeWordingProposalFormPart1.js": [
		293,
		84
	],
	"./DealingWithABodyCorporateClaim": [
		294,
		85
	],
	"./DealingWithABodyCorporateClaim.js": [
		294,
		85
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection": [
		295,
		86
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection.js": [
		295,
		86
	],
	"./DidYouKnowPart1": [
		384,
		87
	],
	"./DidYouKnowPart1.js": [
		384,
		87
	],
	"./DidYouKnowPart2": [
		296,
		55
	],
	"./DidYouKnowPart2.js": [
		296,
		55
	],
	"./DidYouKnowPart3": [
		297,
		56
	],
	"./DidYouKnowPart3.js": [
		297,
		56
	],
	"./DidYouKnowPart4": [
		385,
		6
	],
	"./DidYouKnowPart4.js": [
		385,
		6
	],
	"./DidYouKnowPart5": [
		386,
		7
	],
	"./DidYouKnowPart5.js": [
		386,
		7
	],
	"./DidYouKnowPart6": [
		387,
		8
	],
	"./DidYouKnowPart6.js": [
		387,
		8
	],
	"./EmployersLiability": [
		298,
		88
	],
	"./EmployersLiability.js": [
		298,
		88
	],
	"./EnforcementOfRulesPart1": [
		388,
		16
	],
	"./EnforcementOfRulesPart1.js": [
		388,
		16
	],
	"./EnforcementOfRulesPart2": [
		389,
		17
	],
	"./EnforcementOfRulesPart2.js": [
		389,
		17
	],
	"./EnforcementOfRulesPart4": [
		390,
		18
	],
	"./EnforcementOfRulesPart4.js": [
		390,
		18
	],
	"./EnforecmentOfRulesPart3": [
		391,
		19
	],
	"./EnforecmentOfRulesPart3.js": [
		391,
		19
	],
	"./EnvironmentalUpgradeForGeysers": [
		299,
		89
	],
	"./EnvironmentalUpgradeForGeysers.js": [
		299,
		89
	],
	"./ExamplesOfCxtraCoverFollowingDamage": [
		300,
		90
	],
	"./ExamplesOfCxtraCoverFollowingDamage.js": [
		300,
		90
	],
	"./FidelityFundCertificatesAndCreditChecks": [
		301,
		91
	],
	"./FidelityFundCertificatesAndCreditChecks.js": [
		301,
		91
	],
	"./FireRiskManagementTipsProtectionAgainstFire": [
		302,
		92
	],
	"./FireRiskManagementTipsProtectionAgainstFire.js": [
		302,
		92
	],
	"./FireWisePart1": [
		392,
		93
	],
	"./FireWisePart1.js": [
		392,
		93
	],
	"./FireWisePart10": [
		393,
		94
	],
	"./FireWisePart10.js": [
		393,
		94
	],
	"./FireWisePart11": [
		394,
		95
	],
	"./FireWisePart11.js": [
		394,
		95
	],
	"./FireWisePart12": [
		364,
		96
	],
	"./FireWisePart12.js": [
		364,
		96
	],
	"./FireWisePart13": [
		303,
		97
	],
	"./FireWisePart13.js": [
		303,
		97
	],
	"./FireWisePart14": [
		304,
		98
	],
	"./FireWisePart14.js": [
		304,
		98
	],
	"./FireWisePart15": [
		305,
		0,
		138
	],
	"./FireWisePart15.js": [
		305,
		0,
		138
	],
	"./FireWisePart16": [
		306,
		99
	],
	"./FireWisePart16.js": [
		306,
		99
	],
	"./FireWisePart17": [
		307,
		100
	],
	"./FireWisePart17.js": [
		307,
		100
	],
	"./FireWisePart18": [
		308,
		101
	],
	"./FireWisePart18.js": [
		308,
		101
	],
	"./FireWisePart19": [
		309,
		102
	],
	"./FireWisePart19.js": [
		309,
		102
	],
	"./FireWisePart2": [
		310,
		0,
		136
	],
	"./FireWisePart2.js": [
		310,
		0,
		136
	],
	"./FireWisePart3": [
		311,
		0,
		137
	],
	"./FireWisePart3.js": [
		311,
		0,
		137
	],
	"./FireWisePart4": [
		365,
		103
	],
	"./FireWisePart4.js": [
		365,
		103
	],
	"./FireWisePart6": [
		395,
		104
	],
	"./FireWisePart6.js": [
		395,
		104
	],
	"./FireWisePart7": [
		396,
		105
	],
	"./FireWisePart7.js": [
		396,
		105
	],
	"./FireWisePart8": [
		397,
		106
	],
	"./FireWisePart8.js": [
		397,
		106
	],
	"./FireWisePart9": [
		398,
		107
	],
	"./FireWisePart9.js": [
		398,
		107
	],
	"./FloodRiskManagementTips": [
		312,
		108
	],
	"./FloodRiskManagementTips.js": [
		312,
		108
	],
	"./GeneralConditionsAndProvisions": [
		313,
		109
	],
	"./GeneralConditionsAndProvisions.js": [
		313,
		109
	],
	"./GeneratorPart2": [
		314,
		2
	],
	"./GeneratorPart2.js": [
		314,
		2
	],
	"./GeneratorPart3": [
		315,
		3
	],
	"./GeneratorPart3.js": [
		315,
		3
	],
	"./GeneratorPart4": [
		399,
		20
	],
	"./GeneratorPart4.js": [
		399,
		20
	],
	"./Generators": [
		400,
		21
	],
	"./Generators.js": [
		400,
		21
	],
	"./GeneratorsAndSolarSystems": [
		401,
		110
	],
	"./GeneratorsAndSolarSystems.js": [
		401,
		110
	],
	"./GuidelinesToProtectingYourVacantProperty": [
		316,
		111
	],
	"./GuidelinesToProtectingYourVacantProperty.js": [
		316,
		111
	],
	"./HeavyRainAndFlooding": [
		402,
		9
	],
	"./HeavyRainAndFlooding.js": [
		402,
		9
	],
	"./KZNFlooding": [
		403,
		22
	],
	"./KZNFlooding.js": [
		403,
		22
	],
	"./KeyInformationDocuments": [
		317,
		112
	],
	"./KeyInformationDocuments.js": [
		317,
		112
	],
	"./LayoutOfCiaWording": [
		318,
		113
	],
	"./LayoutOfCiaWording.js": [
		318,
		113
	],
	"./LegislativeRequirementsForCommunitySchemesPart1": [
		319,
		114
	],
	"./LegislativeRequirementsForCommunitySchemesPart1.js": [
		319,
		114
	],
	"./LegislativeRequirementsForCommunitySchemesPart2": [
		320,
		115
	],
	"./LegislativeRequirementsForCommunitySchemesPart2.js": [
		320,
		115
	],
	"./LetsPlayActivityBook": [
		321,
		116
	],
	"./LetsPlayActivityBook.js": [
		321,
		116
	],
	"./LiabilityClaimsMadeVsLossesOccurring": [
		322,
		117
	],
	"./LiabilityClaimsMadeVsLossesOccurring.js": [
		322,
		117
	],
	"./LithiumBatteryFiresPart2": [
		323,
		118
	],
	"./LithiumBatteryFiresPart2.js": [
		323,
		118
	],
	"./LithiumBetteryFires": [
		366,
		119
	],
	"./LithiumBetteryFires.js": [
		366,
		119
	],
	"./LoavesForMandelaDayUpdate": [
		404,
		120
	],
	"./LoavesForMandelaDayUpdate.js": [
		404,
		120
	],
	"./MachineryBreakdown": [
		324,
		121
	],
	"./MachineryBreakdown.js": [
		324,
		121
	],
	"./MessageFromSasriasManagingDirector": [
		325,
		4
	],
	"./MessageFromSasriasManagingDirector.js": [
		325,
		4
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy": [
		326,
		122
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy.js": [
		326,
		122
	],
	"./NewCpdApprovedTraining": [
		327,
		123
	],
	"./NewCpdApprovedTraining.js": [
		327,
		123
	],
	"./NewsletterSubscriberPOPIACompliance": [
		328,
		23
	],
	"./NewsletterSubscriberPOPIACompliance.js": [
		328,
		23
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers": [
		329,
		124
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers.js": [
		329,
		124
	],
	"./OvercrowdingPart1": [
		405,
		24
	],
	"./OvercrowdingPart1.js": [
		405,
		24
	],
	"./OvercrowdingPart2": [
		406,
		25
	],
	"./OvercrowdingPart2.js": [
		406,
		25
	],
	"./PersonalAccident": [
		330,
		125
	],
	"./PersonalAccident.js": [
		330,
		125
	],
	"./ProtectingVacantPropertyPart1": [
		331,
		126
	],
	"./ProtectingVacantPropertyPart1.js": [
		331,
		126
	],
	"./ProtectingVacantPropertyPart3": [
		332,
		127
	],
	"./ProtectingVacantPropertyPart3.js": [
		332,
		127
	],
	"./ProtectingVacantPropertyPart4": [
		333,
		128
	],
	"./ProtectingVacantPropertyPart4.js": [
		333,
		128
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance": [
		334,
		129
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance.js": [
		334,
		129
	],
	"./RisingDamp": [
		335,
		57
	],
	"./RisingDamp.js": [
		335,
		57
	],
	"./RisingDampPart2": [
		336,
		58
	],
	"./RisingDampPart2.js": [
		336,
		58
	],
	"./SadNewsFromCIA": [
		407,
		26
	],
	"./SadNewsFromCIA.js": [
		407,
		26
	],
	"./SasriaClaims": [
		408,
		27
	],
	"./SasriaClaims.js": [
		408,
		27
	],
	"./SasriaRateIncrease1January2022": [
		337,
		5
	],
	"./SasriaRateIncrease1January2022.js": [
		337,
		5
	],
	"./SasriaRateIncrease2025": [
		409,
		1
	],
	"./SasriaRateIncrease2025.js": [
		409,
		1
	],
	"./SasriaWrapCoverAndWordingChanges": [
		361,
		130
	],
	"./SasriaWrapCoverAndWordingChanges.js": [
		361,
		130
	],
	"./The10YearPlanPart1": [
		410,
		28
	],
	"./The10YearPlanPart1.js": [
		410,
		28
	],
	"./The10YearPlanPart2": [
		338,
		29
	],
	"./The10YearPlanPart2.js": [
		338,
		29
	],
	"./The10YearPlanPart3": [
		367,
		30
	],
	"./The10YearPlanPart3.js": [
		367,
		30
	],
	"./The10YearPlanPart4": [
		411,
		31
	],
	"./The10YearPlanPart4.js": [
		411,
		31
	],
	"./TheDevastationOfLithium": [
		359,
		131
	],
	"./TheDevastationOfLithium.js": [
		359,
		131
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies": [
		339,
		132
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies.js": [
		339,
		132
	],
	"./TheftAndCrimeRiskManagement": [
		340,
		133
	],
	"./TheftAndCrimeRiskManagement.js": [
		340,
		133
	],
	"./TrusteesIndemnity": [
		341,
		32
	],
	"./TrusteesIndemnity.js": [
		341,
		32
	],
	"./UnderstandingLiabilityClaimsPart1": [
		412,
		10
	],
	"./UnderstandingLiabilityClaimsPart1.js": [
		412,
		10
	],
	"./UnderstandingLiabilityClaimsPart2": [
		413,
		134
	],
	"./UnderstandingLiabilityClaimsPart2.js": [
		413,
		134
	],
	"./UnderstandingLiabilityClaimsPart3": [
		414,
		11
	],
	"./UnderstandingLiabilityClaimsPart3.js": [
		414,
		11
	],
	"./UnderstandingLiabilityClaimsPart4": [
		415,
		12
	],
	"./UnderstandingLiabilityClaimsPart4.js": [
		415,
		12
	],
	"./UnderstandingLiabilityClaimsPart5": [
		416,
		13
	],
	"./UnderstandingLiabilityClaimsPart5.js": [
		416,
		13
	],
	"./UnderstandingSASRIAExtensions": [
		342,
		14
	],
	"./UnderstandingSASRIAExtensions.js": [
		342,
		14
	],
	"./ValidityOfClaims": [
		343,
		33
	],
	"./ValidityOfClaims.js": [
		343,
		33
	],
	"./ValidityOfClaimsPart2": [
		344,
		34
	],
	"./ValidityOfClaimsPart2.js": [
		344,
		34
	],
	"./WaterLeakageTips": [
		345,
		35
	],
	"./WaterLeakageTips.js": [
		345,
		35
	],
	"./WaterproofingAndWaterIngressPart1": [
		417,
		36
	],
	"./WaterproofingAndWaterIngressPart1.js": [
		417,
		36
	],
	"./WaterproofingAndWaterIngressPart2": [
		418,
		37
	],
	"./WaterproofingAndWaterIngressPart2.js": [
		418,
		37
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy": [
		346,
		38
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy.js": [
		346,
		38
	],
	"./WhatAreGeysersCoveredFor": [
		347,
		39
	],
	"./WhatAreGeysersCoveredFor.js": [
		347,
		39
	],
	"./WhatConstitutesAVoluntaryWorker": [
		348,
		40
	],
	"./WhatConstitutesAVoluntaryWorker.js": [
		348,
		40
	],
	"./WhatDamageRiskManagement": [
		349,
		41
	],
	"./WhatDamageRiskManagement.js": [
		349,
		41
	],
	"./WhatIsASpecificExclusion": [
		350,
		42
	],
	"./WhatIsASpecificExclusion.js": [
		350,
		42
	],
	"./WhatIsCoveredUnderExtraCover": [
		351,
		43
	],
	"./WhatIsCoveredUnderExtraCover.js": [
		351,
		43
	],
	"./WhatIsCoveredUnderTheLiabilitySection": [
		352,
		44
	],
	"./WhatIsCoveredUnderTheLiabilitySection.js": [
		352,
		44
	],
	"./WhatIsExtraCoverFollowingDamage": [
		353,
		45
	],
	"./WhatIsExtraCoverFollowingDamage.js": [
		353,
		45
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover": [
		354,
		46
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover.js": [
		354,
		46
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys": [
		355,
		47
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys.js": [
		355,
		47
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery": [
		356,
		48
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery.js": [
		356,
		48
	],
	"./WhenIsALossadjusterAppointed": [
		357,
		49
	],
	"./WhenIsALossadjusterAppointed.js": [
		357,
		49
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires": [
		358,
		135
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires.js": [
		358,
		135
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 256;
module.exports = webpackAsyncContext;